import axios, { AxiosRequestConfig } from "axios";

import { FormType } from "../components/enums";

import { ApiError } from "./error";

const mapFormType = {
  [FormType.AC as string]: "ac",
  [FormType.OC_VEHICLE as string]: "ocVehicle",
  [FormType.OC_PROPERTY as string]: "ocProperty",
};

const generatePDFEndpoint = (
  apiEndpoint: string,
  caseId: string,
  formType: string
) =>
  `${apiEndpoint}/finish?folderid=${caseId}&formtype=${mapFormType[formType]}`;

export async function generatePDF(
  apiEndpoint: string,
  caseId: string,
  formType: FormType
): Promise<boolean> {
  const config: AxiosRequestConfig = {
    method: "POST",
    url: generatePDFEndpoint(apiEndpoint, caseId, formType),
    headers: {
      "Content-Type": "application/json",
    },
    responseType: "json",
  };

  try {
    await axios(config);

    return true;
  } catch (error) {
    throw new ApiError(error.message);
  }
}
